import { useEffect, useState } from "react";
import "./CustomModal.css";
import { FaUser, FaTimes } from "react-icons/fa";
import { ADMIN_BASE_URL, API_BASE_URL } from "./config";

const Ai2CustomModal = ({ show, onClose, data, onSuccess }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        user_name: "",
        email: "",
        phone_number: "",
        streetAddress: "",
        streetAddress2: "",
        preferred_payment_method: "",
        zelle_id: "",
        crypto_wallet: "",
    });

    // 🔹 Sync data into form
    useEffect(() => {
        if (data) {
            setForm({
                first_name: data.first_name || "",
                last_name: data.last_name || "",
                user_name: data.user_name || "",
                email: data.email || "",
                phone_number: data.phone_number || "",
                streetAddress: data.streetAddress || "",
                streetAddress2: data.streetAddress2 || "",
                preferred_payment_method: data.preferred_payment_method || "",
                zelle_id: data.zelle_id || "",
                crypto_wallet: data.usdc_transaction || "",
            });
        }
    }, [data]);

    if (!show || !data) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const payload = {
                first_name: form.first_name,
                last_name: form.last_name,
                user_name: form.user_name,
                email: form.email,
                phone_number: form.phone_number,
                streetAddress: form.streetAddress,
                streetAddress2: form.streetAddress2,
                preferred_payment_method: form.preferred_payment_method,
                zelle_id: form.zelle_id,
                usdc_transaction: form.crypto_wallet,
            };

            const res = await fetch(`${API_BASE_URL}/ai2/user/${data.id}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok) throw new Error("Update failed");

            alert("AI² user updated successfully");
            onSuccess?.();
            setIsEditing(false);
            onClose();
        } catch (err) {
            console.error(err);
            alert("Failed to update AI² user");
        } finally {
            setLoading(false);
        }
    };

    const renderField = (label, name, isRed = false) => (
        <div className="modal-item">
            <label style={isRed ? { color: "red" } : {}}>{label}</label>
            {isEditing ? (
                <input
                    name={name}
                    value={form[name]}
                    onChange={handleChange}
                    className="custom-input"
                />
            ) : (
                <span>{form[name] || "—"}</span>
            )}
        </div>
    );

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal-container">

                {/* HEADER */}
                <div className="custom-modal-header">
                    <h2>
                        <FaUser className="modal-icon" /> Ai<sup>2</sup> User Details
                    </h2>

                    <div style={{ display: "flex", gap: 10 }}>
                        {isEditing ? (
                            <>
                                <button
                                    className="white-btn"
                                    onClick={handleSave}
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : "Save"}
                                </button>
                                <button
                                    className="white-btn"
                                    onClick={() => setIsEditing(false)}
                                >
                                    Cancel
                                </button>
                            </>
                        ) : (
                            <button
                                className="white-btn"
                                onClick={() => setIsEditing(true)}
                            >
                                Edit
                            </button>
                        )}

                        <button
                            className="modal-close-btn"
                            onClick={() => {
                                setIsEditing(false);
                                onClose();
                            }}
                        >
                            <FaTimes />
                        </button>
                    </div>
                </div>

                {/* BODY */}
                <div className="custom-modal-body">
                    <div className="modal-grid-2col">

                        {renderField("First Name:", "first_name")}
                        {renderField("Username:", "user_name")}
                        {renderField("Last Name:", "last_name")}
                        {renderField("Email:", "email")}

                        {/* 🔒 READ ONLY */}
                        <div className="modal-item">
                            <label>Your Ai<sup>2</sup> Account Created On:</label>
                            <span>
                                {data.user_created_at
                                    ? new Date(data.user_created_at).toLocaleDateString()
                                    : "—"}
                            </span>
                        </div>

                        {renderField("Phone:", "phone_number")}
                        {renderField("Street Address:", "streetAddress")}
                        {renderField("Street Address 2:", "streetAddress2")}

                        {/* PAYMENT */}
                        <div className="modal-item full-width">
                            <label style={{ color: "red" }}>
                                <strong>PREFERRED PAYMENT METHOD:</strong>
                                <div style={{ fontSize: 14 }}>
                                    (so that we can pay you)
                                </div>
                            </label>

                            {isEditing ? (
                                <input
                                    name="preferred_payment_method"
                                    value={form.preferred_payment_method}
                                    onChange={handleChange}
                                    className="custom-input"
                                />
                            ) : (
                                <span>{form.preferred_payment_method || "—"}</span>
                            )}
                        </div>

                        {renderField("Your Zelle ID:", "zelle_id", true)}

                        <div className="modal-item">
                            <label style={{ color: "red" }}>
                                Your Cryptocurrency Wallet:
                                <div style={{ fontSize: 13 }}>(USDC-eth)</div>
                            </label>

                            {isEditing ? (
                                <input
                                    name="crypto_wallet"
                                    value={form.crypto_wallet}
                                    onChange={handleChange}
                                    className="custom-input"
                                />
                            ) : (
                                <span>{form.crypto_wallet || "—"}</span>
                            )}
                        </div>

                    </div>
                </div>

                {/* FOOTER */}
                <div className="custom-modal-footer">
                    <button className="primary-btn" onClick={onClose}>
                        Close
                    </button>
                </div>

            </div>
        </div>
    );
};

export default Ai2CustomModal;
